const entries = [
  { tag: "Field Notes", title: "Why we visit Angkor Wat at 4:47am, not 5:30.", read: "6 min read" },
  { tag: "History", title: "Jayavarman VII and the smile that outlived an empire.", read: "11 min read" },
  { tag: "Travel", title: "What to pack — and what to leave at the hotel.", read: "4 min read" },
];

const Journal = () => (
  <section id="journal" className="bg-background py-28 md:py-36">
    <div className="container">
      <div className="flex items-end justify-between mb-16">
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-5">— The Journal</p>
          <h2 className="font-display text-4xl md:text-6xl">Dispatches from the temples.</h2>
        </div>
        <a href="#" className="hidden md:inline-block text-[11px] uppercase tracking-[0.3em] border-b border-foreground/40 pb-1 hover:text-primary hover:border-primary transition-colors">
          All entries →
        </a>
      </div>
      <div className="grid md:grid-cols-3 gap-px bg-border">
        {entries.map((e, i) => (
          <a key={i} href="#" className="group bg-background p-8 md:p-10 hover:bg-secondary transition-colors">
            <p className="text-[10px] uppercase tracking-[0.3em] text-primary mb-8">{e.tag}</p>
            <h3 className="font-display text-2xl md:text-3xl leading-tight mb-12 text-balance group-hover:text-primary transition-colors">
              {e.title}
            </h3>
            <div className="flex items-center justify-between text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
              <span>{e.read}</span>
              <span className="group-hover:translate-x-1 transition-transform">→</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);
export default Journal;
